/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiSplitSizePolicy {
	FIRST_FIXED, LAST_FIXED, RELATIVE
}